import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';

import DataTable from 'common-components/DataTable';
import Modal from "common-components/Modal";
import axiosInstance from 'axios-config';
import Alert from 'common-components/Alert';
import { SERVER_ERROR, LOGIN_ERROR } from 'common-components/Alert/alertMessage.config';
import { columns } from './catHistoryTableColumns';
import './viewCategoryHistory.style.css';

const ViewCategoryHistory = ({
  authHeader,
  showModal,
  setShowModal,
  catID
}) => {
  const [categiries, setCategories] = useState([])
  const [isLoading, setIsLoading] = useState(true);
  const [alertData, setAlertData] = useState({});

  useEffect(() => {
    getCategoryHistory();
  }, []);

  const formatTableRows = (data) => {
    for (let i = 0; i < data.length; i++) {
      data[i]["users"] = data[i]["users"]["username"];
      data[i]["created_timestamp"] = data[i]["created_timestamp"]
        .replace('T', ' ')
        .replace(/\.[0-9]*Z/i, "");
    };
    setCategories(data);
  };

  const getCategoryHistory = async () => {
    setIsLoading(true);

    await axiosInstance.get(`/category/detail_category/${catID}/`,
      { headers: authHeader })
      .then((response) => {
        if (response.status.toString().match(/2\d{2}/)) {
          formatTableRows(response.data.results);
        } else {
          console.log(response);
          setAlertData(SERVER_ERROR);
        };
      })
      .catch((error) => {
        console.log(error);
        let _s = error.message.split(' ')
        let status = parseInt(_s[_s.length - 1])
        if (status == 401) {
          setAlertData(LOGIN_ERROR);
        } else setAlertData(SERVER_ERROR);
      });

    setIsLoading(false);
  };

  const modalContent = () => {
    return (
      <>
        <div className='cat-history-table-container'>
          <DataTable
            title="Category History"
            wrapperClassName='cat-history-table'
            rows={categiries}
            columns={columns}
            pageSizeOptions={[5]}
            searchableFields={["detailed_category_name", "detailed_category_id", "users"]}
            isLoading={isLoading}
          />
        </div>
        <Alert
          showModal={alertData.showModal}
          setShowModal={setAlertData}
          data={alertData}
        />
      </>
    )
  };

  return (
    <div className='cat-history-modal-wrap'>
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        content={modalContent()} />
    </div>
  );
};

const mapStateToProps = ({
  authentication: { authHeader } }) => ({
    authHeader
  });

export default connect(mapStateToProps)(ViewCategoryHistory);